<template>
  <div class="bg-white px-4 py-5 shadow-sm sm:rounded-md sm:p-6">
    <slot></slot>
  </div>
</template>
